import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { formatearFechaHora } from "../../helpers/formato";

/**
 * Bloque de parámetros del reporte y bloque del usuario que lo genera, con fecha y hora
 * DD/MM/YYYY hh:mm A. Lo usan la pantalla y la hoja impresa.
 *
 * @param {object} props
 * @param {{label: string, valor: React.ReactNode}[]} [props.parametros] Se muestran como "label: valor".
 * @param {string} [props.usuario]
 * @param {string} [props.rol]
 * @param {number} [props.tamano] Tamaño de letra en px (por defecto 12).
 * @param {string} [props.colorEtiqueta] Color de "Parámetros:" y "Usuario:" (en papel, negro).
 */
export const ParametrosReporte = ({
  parametros = [],
  usuario,
  rol,
  tamano = 12,
  colorEtiqueta = "text.secondary",
}) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="flex-start"
    spacing={2}
    sx={{ textAlign: "left" }}
  >
    <Box>
      <Typography fontSize={tamano} sx={{ color: colorEtiqueta, fontWeight: "bold" }}>
        Parámetros:
      </Typography>
      {parametros.map((p) => (
        <Typography key={p.label} fontSize={tamano}>
          {p.label}: {p.valor}
        </Typography>
      ))}
    </Box>
    <Box>
      <Typography fontSize={tamano} sx={{ color: colorEtiqueta, fontWeight: "bold" }}>
        Usuario:
      </Typography>
      <Typography fontSize={tamano}>{rol ? `${usuario} - ${rol}` : usuario}</Typography>
      <Typography fontSize={tamano}>{`Fecha y hora: ${formatearFechaHora(new Date())}`}</Typography>
    </Box>
  </Stack>
);

export default ParametrosReporte;
